import "core-js/modules/es6.weak-map";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.map";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.number.is-integer";
import "core-js/modules/es7.object.values";
import "core-js/modules/es7.object.entries";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import { __assign, __makeTemplateObject, __spreadArray } from 'tslib';
import React, { createContext, useRef, useCallback, useMemo, useEffect, useReducer, useContext, useState } from 'react';
import { Howler, Howl } from 'howler';
import { useEnhancedEffect, Box } from '@landr/maestro';
import styled, { css } from 'styled-components';
import debounce from 'lodash.debounce';
var PlayerActionTypes;

(function (PlayerActionTypes) {
  PlayerActionTypes["INIT_PLAYER"] = "PLAYER/INIT_PLAYER";
  PlayerActionTypes["DESTROY_PLAYER"] = "PLAYER/DESTROY_PLAYER";
  PlayerActionTypes["DESTROY_ALL_PLAYERS"] = "PLAYER/DESTROY_ALL_PLAYERS";
  PlayerActionTypes["SET_LOADING"] = "PLAYER/SET_LOADING";
  PlayerActionTypes["SET_PLAYING"] = "PLAYER/SET_PLAYING";
  PlayerActionTypes["SET_SOURCES"] = "PLAYER/SET_SOURCES";
  PlayerActionTypes["SET_ACTIVE_SOURCE_ID"] = "PLAYER/SET_ACTIVE_SOURCE_ID";
  PlayerActionTypes["SET_CURRENT_TIME"] = "PLAYER/SET_CURRENT_TIME";
  PlayerActionTypes["SET_TOTAL_TIME"] = "PLAYER/SET_TOTAL_TIME";
  PlayerActionTypes["SET_ERROR"] = "PLAYER/SET_ERROR";
  PlayerActionTypes["SET_VOLUME"] = "PLAYER/SET_VOLUME";
  PlayerActionTypes["SEEK"] = "PLAYER/SEEK";
  PlayerActionTypes["LOAD"] = "PLAYER/LOAD";
  PlayerActionTypes["SET_LOOP"] = "PLAYER/SET_LOOP";
})(PlayerActionTypes || (PlayerActionTypes = {}));

var initPlayer = function initPlayer(dispatch, id, value) {
  return dispatch({
    type: PlayerActionTypes.INIT_PLAYER,
    id: id,
    value: {
      recreate: value,
      dispatch: dispatch
    }
  });
};

var destroyPlayer = function destroyPlayer(dispatch, id) {
  return dispatch({
    type: PlayerActionTypes.DESTROY_PLAYER,
    id: id,
    value: null
  });
};

var destroyAllPlayers = function destroyAllPlayers(dispatch) {
  return dispatch({
    type: PlayerActionTypes.DESTROY_ALL_PLAYERS,
    value: null
  });
};

var load = function load(dispatch, id, value) {
  return dispatch({
    type: PlayerActionTypes.LOAD,
    id: id,
    value: value
  });
};

var setPlaying = function setPlaying(dispatch, id, value) {
  return dispatch({
    type: PlayerActionTypes.SET_PLAYING,
    id: id,
    value: value
  });
};

var setLoading = function setLoading(dispatch, id, value) {
  return dispatch({
    type: PlayerActionTypes.SET_LOADING,
    id: id,
    value: value
  });
};

var setError = function setError(dispatch, id, value) {
  return dispatch({
    type: PlayerActionTypes.SET_ERROR,
    id: id,
    value: value
  });
};

var setSources = function setSources(dispatch, id, value) {
  return dispatch({
    type: PlayerActionTypes.SET_SOURCES,
    id: id,
    value: value
  });
};

var setActiveSourceId = function setActiveSourceId(dispatch, id, value) {
  return dispatch({
    type: PlayerActionTypes.SET_ACTIVE_SOURCE_ID,
    id: id,
    value: value
  });
};

var setVolume = function setVolume(dispatch, id, value) {
  return dispatch({
    type: PlayerActionTypes.SET_VOLUME,
    id: id,
    value: value
  });
};

var setTotalTime = function setTotalTime(dispatch, id, value) {
  return dispatch({
    type: PlayerActionTypes.SET_TOTAL_TIME,
    id: id,
    value: value
  });
};

var seek = function seek(dispatch, id, value, playOnSeek) {
  if (playOnSeek === void 0) {
    playOnSeek = true;
  }

  dispatch({
    type: PlayerActionTypes.SEEK,
    id: id,
    value: value
  });

  if (playOnSeek) {
    setPlaying(dispatch, id, true);
  }
};

var setLoop = function setLoop(dispatch, id, value) {
  dispatch({
    type: PlayerActionTypes.SET_LOOP,
    id: id,
    value: value
  });
};

var CurrentTimePubSub =
/** @class */
function () {
  function CurrentTimePubSub() {
    var _this = this;

    this.currentTimes = {};
    this.EventName = 'LANDR.WEB.REACTPLAYER - currentTime Update ';

    this.setCurrentTime = function (value, playerId) {
      _this.currentTimes[playerId] = value;
      document.dispatchEvent(new Event(_this.EventName));
    };

    this.subscribeToCurrentTime = function (callback) {
      var listener = function listener() {
        callback(_this.currentTimes);
      };

      document.addEventListener(_this.EventName, listener);
      return {
        unsubscribe: function unsubscribe() {
          document.removeEventListener(_this.EventName, listener);
        }
      };
    };
  }

  CurrentTimePubSub.getInstance = function () {
    if (!CurrentTimePubSub.instance) {
      CurrentTimePubSub.instance = new CurrentTimePubSub();
    }

    return CurrentTimePubSub.instance;
  };

  return CurrentTimePubSub;
}();

var PlayerStateEnum;

(function (PlayerStateEnum) {
  PlayerStateEnum["playing"] = "playing";
  PlayerStateEnum["paused"] = "paused";
  PlayerStateEnum["stopped"] = "stopped";
})(PlayerStateEnum || (PlayerStateEnum = {}));

var EventIds;

(function (EventIds) {
  EventIds[EventIds["MediaLoadFailed"] = 14000] = "MediaLoadFailed";
  EventIds[EventIds["SourceUpdated"] = 14001] = "SourceUpdated";
  EventIds[EventIds["Played"] = 14002] = "Played";
  EventIds[EventIds["Paused"] = 14003] = "Paused";
  EventIds[EventIds["MediaPlayFailed"] = 14004] = "MediaPlayFailed";
  EventIds[EventIds["LoadSourceFailed"] = 14005] = "LoadSourceFailed";
})(EventIds || (EventIds = {}));

var removeParamsFromUrl = function removeParamsFromUrl(urlString) {
  try {
    var url = new URL(urlString);
    return "" + url.origin + url.pathname;
  } catch (error) {
    return urlString;
  }
}; // Minimum time (in secs) between which two howls will sync their current times.
// Below this duration, no sync will be done to avoid audio issues with too many sync.


var SYNC_MINIMUM_DELTA = 0.05; // Increase the html5 pool size as we can have a lot of sources loaded at the same time (ex: Detail + preview)
// howler will unlock all sources in the html5 sources pool as soon as the user click somewhere

Howler.html5PoolSize = 30;

var HowlerPlayerService =
/** @class */
function () {
  function HowlerPlayerService(log, playerId, dispatch) {
    this.playerId = playerId;
    this.dispatch = dispatch;
    this.state = PlayerStateEnum.stopped;
    this.currentTime = 0;
    this.duration = 0;
    this.ready = false;
    this.loadError = null; // Public for tests only

    this.howls = {};
    this.activeSource = null;
    this.timeUpdateInterval = null;
    this.adjustedUpdateTimeFrequency = 100;
    this.currentTimePubSub = CurrentTimePubSub.getInstance();
    this.log = log.getInstance('LrPlayerComponent ::');
  }
  /**
   * Get the current time of a howl.
   * It checks for `instanceof` because `seek` can return the howl if it's not initialized
   * @param {Howl} howl
   * @returns {number}
   */


  HowlerPlayerService.getHowlCurrentTime = function (howl) {
    var currentTime = howl.seek();
    return currentTime instanceof Howl ? 0 : currentTime;
  };

  HowlerPlayerService.prototype.addSources = function (sources) {
    var _this = this;

    sources.forEach(function (source) {
      // Stems create a source without formats, so no need to create an howl
      if (source.url) {
        _this.howls[source.id] = _this.createHowl(source);
      }
    });
  };

  HowlerPlayerService.prototype.removeSources = function (sources) {
    var _this = this;

    sources.forEach(function (source) {
      var _a;

      (_a = _this.howls[source.id]) === null || _a === void 0 ? void 0 : _a.unload();
      delete _this.howls[source.id];
    });
  };

  HowlerPlayerService.prototype.setActiveSource = function (source) {
    this.activeSource = source;

    if (this.state === PlayerStateEnum.playing) {
      this.syncAllHowls(); // this actually does the job of mute/unmute howls

      this.play();
    }
  };

  HowlerPlayerService.prototype.setVolume = function (value) {
    if (!this.activeSource) {
      this.log.debug('no active source to update volume', EventIds.Played, {
        playerId: this.playerId
      });
      return;
    }

    this.howls[this.activeSource.id].volume(value);
  };

  HowlerPlayerService.prototype.setReady = function (value) {
    this.ready = value;
  };

  HowlerPlayerService.prototype.setAdjustedUpdateTimeFrequency = function (value) {
    this.adjustedUpdateTimeFrequency = value;
  };
  /**
   * Load specific source by sourceId when preload was first set to false
   */


  HowlerPlayerService.prototype.load = function (sourceId) {
    try {
      var howl = this.howls[sourceId];

      if (!howl) {
        this.log.debug('no source to load', EventIds.LoadSourceFailed, {
          playerId: this.playerId
        });
        return;
      }

      howl.load();
    } catch (e) {
      this.log.debug('error manually loading a source', EventIds.LoadSourceFailed, {
        playerId: this.playerId
      });
    }
  };
  /**
   * Plays all sources. The switch of active source is done with `mute`, by unmuting the active source and muting
   * others.
   * Starts an interval to update `currentTime`.
   */


  HowlerPlayerService.prototype.play = function () {
    var _this = this;

    this.state = PlayerStateEnum.playing;

    if (!this.activeSource) {
      this.log.debug('no active source to play', EventIds.Played, {
        playerId: this.playerId
      });
      return;
    }

    if (Object.keys(this.howls).length === 0) {
      this.log.error('no howl to play/mute', EventIds.Played, undefined, {
        playerId: this.playerId
      });
      return;
    }

    this.log.info('play', undefined, {
      playerId: this.playerId
    });
    var activeSourceId = this.activeSource.id;
    Object.entries(this.howls).forEach(function (_a) {
      var sourceId = _a[0],
          howl = _a[1];
      howl.mute(activeSourceId !== sourceId);

      if (!howl.playing() && howl.state() !== 'loading') {
        if (_this.ready) {
          howl.play();

          _this.startAdjustedUpdateTime();
        } else {
          howl.load();
        }
      }
    });

    if (!this.ready) {
      // We could be in a dispatch already, so we'll dispatch the loading state for next tick
      setTimeout(function () {
        return setLoading(_this.dispatch, _this.playerId, true);
      });
    }
  };
  /**
   * Pause all sources.
   * Stop the interval that updates `currentTime`.
   */


  HowlerPlayerService.prototype.pause = function () {
    if (this.ready) {
      this.log.info('pause', undefined, {
        playerId: this.playerId
      });
    }

    if (this.ready && Object.keys(this.howls).length === 0) {
      this.log.error('no howl to pause', EventIds.Paused, undefined, {
        playerId: this.playerId
      });
    }

    Object.values(this.howls).forEach(function (howl) {
      return howl.pause();
    });
    this.state = PlayerStateEnum.paused;
    this.stopAdjustedUpdateTime();
  };

  HowlerPlayerService.prototype.toggle = function () {
    if (this.state === PlayerStateEnum.playing) {
      this.pause();
    } else {
      this.play();
    }
  };

  HowlerPlayerService.prototype.seek = function (valueInMs) {
    this.log.info('seek', undefined, {
      valueInMs: valueInMs,
      playerId: this.playerId
    });
    var valueInSec = valueInMs / 1000;

    if (!this.activeSource || !this.duration) {
      this.log.info('no active source or duration unknown', undefined, {
        duration: this.duration,
        activeSourceId: this.activeSource,
        playerId: this.playerId
      });
      return;
    }

    Object.values(this.howls).forEach(function (howl) {
      return howl.seek(valueInSec);
    });
  };

  HowlerPlayerService.prototype.loop = function (loop) {
    Object.values(this.howls).forEach(function (howl) {
      return howl.loop(loop);
    });
  };

  HowlerPlayerService.prototype.onDestroy = function () {
    if (this.state === PlayerStateEnum.playing) {
      this.pause();
    }

    Object.values(this.howls).forEach(function (howl) {
      return howl === null || howl === void 0 ? void 0 : howl.unload();
    });
    this.howls = {};
  };

  HowlerPlayerService.prototype.createHowl = function (source) {
    var _this = this;

    if (source.preload) {
      // We could be in a dispatch already, so we'll dispatch the loading state for next tick
      setTimeout(function () {
        return setLoading(_this.dispatch, _this.playerId, true);
      });
    }

    var howl = new Howl({
      // HTML 5 is needed until we figure out why, when disabled, it's downloading the full track before being able
      // to play. This is blocker for mobile. HTML5 fallback works well
      html5: true,
      src: [source.url],
      // Format is optional, but if your url doesn't finish with .mp3 or .ogg, it won't detect the format properly
      format: ['mp3'],
      preload: !!source.preload,
      // autoplay: true,
      loop: false
    }); // Once is used to unregister the callback after it's called the first time

    howl.once('load', function () {
      _this.log.debug('Howl loaded', undefined, {
        sourceId: source.id,
        playerId: _this.playerId
      });

      _this.onHowlReady(howl, source.id);
    }); // eslint-disable-next-line @typescript-eslint/no-explicit-any

    howl.once('playerror', function (id, error) {
      _this.log.error('unable to play source', EventIds.MediaPlayFailed, error, {
        sourceId: source.id,
        sourceUrl: removeParamsFromUrl(source.url),
        sourcePreload: source.preload,
        playerId: _this.playerId
      });

      _this.loadError = error;
      setTimeout(function () {
        return setError(_this.dispatch, _this.playerId, error);
      });
    }); // eslint-disable-next-line @typescript-eslint/no-explicit-any

    howl.once('loaderror', function (id, error) {
      if (Number.isInteger(error)) {
        error = {
          message: 'HTML5 Audio error',
          code: error
        };
      }

      _this.log.error('unable to load source', EventIds.MediaLoadFailed, error, {
        sourceId: source.id,
        sourceUrl: removeParamsFromUrl(source.url),
        sourcePreload: source.preload,
        playerId: _this.playerId
      });

      _this.loadError = error;
      setTimeout(function () {
        return setError(_this.dispatch, _this.playerId, error);
      });
    });
    howl.on('seek', function () {
      return _this.onHowlSeek(howl, source.id);
    });
    howl.on('end', function () {
      return _this.onHowlEnd(source.id);
    });
    return howl;
  };
  /**
   * Called when a howl has seeked. Meaning it actually moved its current time and it's ready to play.
   * If there is a low network, `onHowlSeek` can be called with a bigger latency after `seek(value)` is called.
   * @param {Howl} howl
   * @param {string} sourceId
   */


  HowlerPlayerService.prototype.onHowlSeek = function (howl, sourceId) {
    this.log.debug('onHowlSeek :: Howl seeked', undefined, {
      sourceId: sourceId,
      playerId: this.playerId
    });

    if (this.activeSource && this.activeSource.id === sourceId) {
      this.syncAllHowls();
    }
  };
  /**
   * Howl has reached the end. It will stop setInterval timer that updates `currentTime`
   * @param {string} sourceId
   */


  HowlerPlayerService.prototype.onHowlEnd = function (sourceId) {
    var _this = this;

    this.log.debug('onHowlEnd', undefined, {
      sourceId: sourceId,
      playerId: this.playerId
    });

    if (this.activeSource && this.activeSource.id === sourceId) {
      var howl = this.howls[this.activeSource.id];

      if (!howl.loop()) {
        this.stopAdjustedUpdateTime(true);
        setTimeout(function () {
          return setPlaying(_this.dispatch, _this.playerId, false);
        });
      }
    }
  };
  /**
   * Updates the current time of a howl if it's out of sync from the active source.
   * The sync will happen only if the difference from active source is over a delta set by `SYNC_MINIMUM_DELTA`
   * @param {Howl} howl howl to sync
   * @param {string} sourceId id of the howl to sync. This is for logging purpose
   */


  HowlerPlayerService.prototype.syncHowl = function (howl, sourceId) {
    var activeHowl = this.activeSource ? this.howls[this.activeSource.id] : null;

    if (activeHowl && howl !== activeHowl) {
      var activeHowlCurrentTime = HowlerPlayerService.getHowlCurrentTime(activeHowl);
      var howlCurrentTime = HowlerPlayerService.getHowlCurrentTime(howl);
      var deltaToSync = Math.abs(howlCurrentTime - activeHowlCurrentTime);

      if (deltaToSync > SYNC_MINIMUM_DELTA) {
        howl.seek(activeHowlCurrentTime);
        this.log.debug('syncHowl - SYNCED', undefined, {
          sourceId: sourceId,
          deltaToSync: deltaToSync,
          playerId: this.playerId
        });
      }
    }
  };

  HowlerPlayerService.prototype.syncAllHowls = function () {
    var _this = this;

    Object.entries(this.howls).forEach(function (_a) {
      var sourceId = _a[0],
          howl = _a[1];

      _this.syncHowl(howl, sourceId);
    });
  };

  HowlerPlayerService.prototype.startAdjustedUpdateTime = function () {
    var _this = this;

    this.log.debug('startAdjustedUpdateTime', undefined, {
      playerId: this.playerId,
      timeUpdateInterval: !!this.timeUpdateInterval
    });

    if (!this.timeUpdateInterval) {
      this.log.debug('startAdjustedUpdateTime::starting', undefined, {
        playerId: this.playerId
      });
      this.timeUpdateInterval = window.setInterval(function () {
        var howl = _this.activeSource ? _this.howls[_this.activeSource.id] : null;

        if (howl) {
          var currentTime = HowlerPlayerService.getHowlCurrentTime(howl);
          _this.currentTime = currentTime * 1000;

          _this.currentTimePubSub.setCurrentTime(_this.currentTime, _this.playerId);
        }
      }, this.adjustedUpdateTimeFrequency);
    }
  };
  /**
   * Stops the interval started by `startAdjustedUpdateTime`.
   *
   * @param {boolean} hasEnded update `state` and `currentTime` to an complete state if is `true`
   */


  HowlerPlayerService.prototype.stopAdjustedUpdateTime = function (hasEnded) {
    if (hasEnded === void 0) {
      hasEnded = false;
    }

    this.log.debug('stopAdjustedUpdateTime', undefined, {
      playerId: this.playerId,
      timeUpdateInterval: !!this.timeUpdateInterval
    });

    if (this.timeUpdateInterval) {
      this.log.debug('stopAdjustedUpdateTime::stopping', undefined, {
        playerId: this.playerId
      });
      window.clearInterval(this.timeUpdateInterval);
      this.timeUpdateInterval = null;

      if (hasEnded) {
        this.state = PlayerStateEnum.stopped;
        this.currentTime = this.duration;
        this.currentTimePubSub.setCurrentTime(this.currentTime, this.playerId);
      }
    }
  };
  /**
   * Triggered when the howl is loaded and ready to play.
   *
   * Will initialize player `ready`, `duration` and call `onPlayerReady` binding if all howls are ready.
   *
   * If the state is playing, we force all sources to play. This happens when a new source is inserted when we are
   * already playing.
   * @param {Howl} howl
   * @param {string} sourceId
   */


  HowlerPlayerService.prototype.onHowlReady = function (howl, sourceId) {
    var _this = this;

    if (this.ready) {
      this.log.debug('onHowlReady :: player already ready', undefined, {
        playerId: this.playerId
      });
      return;
    }

    if (!Object.values(this.howls).every(function (h) {
      return h.state() === 'loaded';
    })) {
      this.log.debug('onHowlReady :: Not all sources are ready', undefined, {
        playerId: this.playerId
      });
      return;
    }

    this.log.debug('onHowlReady :: All sources are ready', undefined, {
      playerId: this.playerId
    });
    this.ready = true;
    this.duration = howl.duration() * 1000; // We could be in a dispatch already, so we'll dispatch in the next tick

    setTimeout(function () {
      setTotalTime(_this.dispatch, _this.playerId, _this.duration);
      setLoading(_this.dispatch, _this.playerId, false);
    });

    if (this.state === PlayerStateEnum.playing) {
      this.syncHowl(howl, sourceId);
      this.play();
    }
  };

  return HowlerPlayerService;
}();

var log;

var setLogger = function setLogger(value) {
  return log = value;
};

var getInitialState = function getInitialState() {
  return {
    playing: false,
    sources: [],
    activeSourceId: '',
    totalTime: 0,
    service: null,
    referenceCount: 0,
    loading: false,
    error: null,
    loop: false
  };
};

function getPlayerStateById(globalState, id) {
  if (!id) {
    return getInitialState();
  }

  return globalState.statesById[id] || getInitialState();
}

function updatePlayerStateById(globalState, id, playerState) {
  var _a;

  return __assign(__assign({}, globalState), {
    statesById: __assign(__assign({}, globalState.statesById), (_a = {}, _a[id] = playerState, _a))
  });
}

function trackSourceFormat(source) {
  var src = source.url;
  return source.id + "-" + src;
}
/**
 * Compare two sources based on their id and format source.
 * This is used to detect if sources really changed, or if it's just a new instance with the same content.
 * @param {PlayerSource} s1
 * @param {PlayerSource} s2
 * @returns {boolean} true if they are the same
 */


function areSourcesEqual(s1, s2) {
  return trackSourceFormat(s1) === trackSourceFormat(s2);
}

function compareAndUpdateSources(newSources, oldSources) {
  if (oldSources === void 0) {
    oldSources = [];
  } // Compute sources removed from actual list of sources


  var sourcesRemoved = oldSources.filter(function (actualSource) {
    return !newSources.some(function (newSource) {
      return areSourcesEqual(actualSource, newSource);
    });
  }); // Update sources with previous sources flags

  var sourcesAddedOrUpdated = newSources.filter(function (newSource) {
    return !oldSources.find(function (source) {
      return areSourcesEqual(source, newSource);
    });
  });
  return {
    sourcesRemoved: sourcesRemoved,
    sourcesAddedOrUpdated: sourcesAddedOrUpdated
  };
}

function getNewActiveSourceId(service, sources, newActiveSourceId) {
  if (service) {
    var activeSource = sources.find(function (source) {
      return source.id === newActiveSourceId;
    });

    if (!activeSource && sources && sources.length) {
      // No active source found, fallback to first item
      activeSource = sources[0];
    }

    if (activeSource) {
      service.setActiveSource(activeSource);
      newActiveSourceId = activeSource.id;
    }
  }

  return newActiveSourceId;
}

function handleActiveSourceUpdate(globalState, action) {
  var playerId = action.id;
  var playerState = getPlayerStateById(globalState, playerId);
  var service = playerState.service,
      sources = playerState.sources;
  var newActiveSourceId = getNewActiveSourceId(service, sources, action.value);
  return updatePlayerStateById(globalState, playerId, __assign(__assign({}, playerState), {
    activeSourceId: newActiveSourceId,
    sources: sources
  }));
}

function handleSourceLoad(globalState, action) {
  var playerId = action.id;
  var playerState = getPlayerStateById(globalState, playerId);
  var service = playerState.service;

  if (service) {
    service.load(action.value);
  }

  return __assign({}, globalState);
}

function handleVolumeUpdate(globalState, action) {
  var playerId = action.id;
  var playerState = getPlayerStateById(globalState, playerId);
  var service = playerState.service;

  if (service) {
    service.setVolume(action.value);
  }

  return __assign({}, globalState);
}

function handleSourceUpdate(globalState, action) {
  var playerId = action.id;
  var playerState = getPlayerStateById(globalState, playerId);
  var service = playerState.service,
      sources = playerState.sources,
      activeSourceId = playerState.activeSourceId,
      playing = playerState.playing;
  var newSources = action.value;

  if (!service || sources === newSources) {
    return updatePlayerStateById(globalState, playerId, __assign(__assign({}, playerState), {
      sources: newSources
    }));
  }

  var _a = compareAndUpdateSources(newSources, sources),
      sourcesRemoved = _a.sourcesRemoved,
      sourcesAddedOrUpdated = _a.sourcesAddedOrUpdated; // Back to not ready if there is new sources to load


  if (sourcesAddedOrUpdated.length > 0) {
    service.setReady(false);
  } // Add/Remove howls


  service.removeSources(sourcesRemoved); // TODO loop is the 2nd param

  service.addSources(sourcesAddedOrUpdated);

  if (playing) {
    service.play();
  }

  var newActiveSourceId = getNewActiveSourceId(service, newSources, activeSourceId);
  return updatePlayerStateById(globalState, playerId, __assign(__assign({}, playerState), {
    sources: newSources,
    activeSourceId: newActiveSourceId
  }));
}

function handlePlayingUpdate(globalState, playerId, newPlaying) {
  var _a;

  var newStatesById = Object.keys(globalState.statesById).reduce(function (acc, id) {
    var playerState = globalState.statesById[id];

    if (playerState.service) {
      playerState.service.pause();
    }

    acc[id] = __assign(__assign({}, playerState), {
      playing: false,
      loading: id === playerId ? playerState.loading : false
    });
    return acc;
  }, (_a = {}, _a[playerId] = getPlayerStateById(globalState, playerId), _a));

  if (newPlaying) {
    newStatesById[playerId] = __assign(__assign({}, newStatesById[playerId]), {
      playing: true
    });
    var service = newStatesById[playerId].service;

    if (service) {
      service.play();
    }
  }

  return __assign(__assign({}, globalState), {
    statesById: newStatesById
  });
} // Reducer


var playerReducer = function playerReducer(globalState, action) {
  // This is only used when the provider id destroyed
  // Note that all players will be destroyed no matter reference count
  if (action.type === PlayerActionTypes.DESTROY_ALL_PLAYERS) {
    var newGlobalState_1 = Object.assign({}, globalState);
    Object.keys(globalState.statesById).forEach(function (id) {
      globalState.statesById[id] && globalState.statesById[id].service && globalState.statesById[id].service.onDestroy();
      newGlobalState_1 = updatePlayerStateById(newGlobalState_1, id, getInitialState());
    });
    return __assign({}, newGlobalState_1);
  }

  if (!action.id) {
    return globalState;
  }

  var playerState = getPlayerStateById(globalState, action.id);

  switch (action.type) {
    case PlayerActionTypes.INIT_PLAYER:
      {
        if (action.value.recreate && playerState.service) {
          playerState.service.onDestroy();
        }

        var newState = action.value.recreate ? getInitialState() : playerState;
        var service = newState.service;

        if (!newState.service && newState.referenceCount === 0) {
          service = new HowlerPlayerService(log, action.id, action.value.dispatch);
        }

        return updatePlayerStateById(globalState, action.id, __assign(__assign({}, newState), {
          referenceCount: action.value.recreate ? playerState.referenceCount : newState.referenceCount + 1,
          service: service
        }));
      }

    case PlayerActionTypes.DESTROY_PLAYER:
      if (playerState.service && playerState.referenceCount - 1 === 0) {
        playerState.service.onDestroy();
        return updatePlayerStateById(globalState, action.id, getInitialState());
      }

      return updatePlayerStateById(globalState, action.id, __assign(__assign({}, playerState), {
        referenceCount: playerState.referenceCount - 1
      }));

    case PlayerActionTypes.SET_LOADING:
      return updatePlayerStateById(globalState, action.id, __assign(__assign({}, playerState), {
        loading: action.value
      }));

    case PlayerActionTypes.SET_PLAYING:
      return handlePlayingUpdate(globalState, action.id, action.value);

    case PlayerActionTypes.SET_ERROR:
      return updatePlayerStateById(globalState, action.id, __assign(__assign({}, playerState), {
        error: action.value
      }));

    case PlayerActionTypes.SET_SOURCES:
      return handleSourceUpdate(globalState, action);

    case PlayerActionTypes.SET_ACTIVE_SOURCE_ID:
      return handleActiveSourceUpdate(globalState, action);

    case PlayerActionTypes.LOAD:
      return handleSourceLoad(globalState, action);

    case PlayerActionTypes.SET_VOLUME:
      return handleVolumeUpdate(globalState, action);

    case PlayerActionTypes.SET_TOTAL_TIME:
      return updatePlayerStateById(globalState, action.id, __assign(__assign({}, playerState), {
        totalTime: action.value
      }));

    case PlayerActionTypes.SEEK:
      {
        if (playerState.service) {
          playerState.service.seek(action.value);
        }

        var currentTimePubSub = CurrentTimePubSub.getInstance();
        currentTimePubSub.setCurrentTime(action.value, action.id);
        return globalState;
      }

    case PlayerActionTypes.SET_LOOP:
      {
        if (playerState.service) {
          playerState.service.loop(action.value);
        }

        return updatePlayerStateById(globalState, action.id, __assign(__assign({}, playerState), {
          loop: action.value
        }));
      }

    default:
      return globalState;
  }
};

var PlayerWaveformContext = createContext({
  requestRender: function requestRender(_d) {
    return undefined;
  },
  cancelRender: function cancelRender(_d) {
    return undefined;
  }
});

var PlayerWaveformProvider = function PlayerWaveformProvider(_a) {
  var children = _a.children;
  var drawersRef = useRef([]);
  var animationFrameHandleRef = useRef(null);
  var render = useCallback(function () {
    var updateDrawers = function updateDrawers() {
      var currentDrawers = drawersRef.current; // Clear current ref as `drawer.update()` could add new values

      drawersRef.current = [];
      currentDrawers.forEach(function (drawer) {
        return drawer.update();
      });

      if (currentDrawers.length > 0) {
        requestAnimationFrame(updateDrawers);
      } else {
        // Stop requestAnimationFrame calls
        animationFrameHandleRef.current = null;
      }
    };

    animationFrameHandleRef.current = requestAnimationFrame(updateDrawers);
  }, []);
  var state = useMemo(function () {
    return {
      requestRender: function requestRender(drawer) {
        drawersRef.current.push(drawer);

        if (animationFrameHandleRef.current === null) {
          // will call requestAnimationFrame if none is setup already
          render();
        }
      },
      cancelRender: function cancelRender(drawer) {
        var index = drawersRef.current.indexOf(drawer);

        if (index > -1) {
          drawersRef.current.splice(index, 1);
        }
      }
    };
  }, []);
  return React.createElement(PlayerWaveformContext.Provider, {
    value: state
  }, children);
};

var PlayerContext = createContext({
  state: {
    activePlayerId: '',
    statesById: {}
  },
  dispatch: function dispatch() {
    return undefined;
  }
});

var PlayerStoreProvider = function PlayerStoreProvider(_a) {
  var children = _a.children;

  var _b = useReducer(playerReducer, {
    activePlayerId: '',
    statesById: {}
  }),
      state = _b[0],
      dispatch = _b[1];

  var destroyAllPlayers$1 = useCallback(function () {
    return destroyAllPlayers(dispatch);
  }, [dispatch]);
  useEffect(function () {
    return destroyAllPlayers$1;
  }, [destroyAllPlayers$1]);
  return React.createElement(PlayerContext.Provider, {
    value: {
      state: state,
      dispatch: dispatch
    }
  }, children);
};

var PlayerProvider = function PlayerProvider(_a) {
  var children = _a.children,
      logProp = _a.log;
  setLogger(logProp);
  useEffect(function () {
    // This is necessary for unlocking the audio context on Safari and mobile devices.
    // Howler watches (in its global context) for touch or click event to unlock the first play
    // https://github.com/goldfire/howler.js#mobilechrome-playback
    // https://stackoverflow.com/questions/34665417/safari-and-mobile-safari-require-page-refresh-to-play-howler-audio
    new Howl({
      // It doesn't matter if we don't find the source, we just need Howler to be called at app initialization
      // Also this source will not be fetched because `preload` is `false` by default
      src: 'notfound.mp3',
      html5: true,
      preload: false
    });
  }, []);
  return React.createElement(PlayerStoreProvider, null, React.createElement(PlayerWaveformProvider, null, children));
};

var usePlayerContext = function usePlayerContext(playerId) {
  var _a = useContext(PlayerContext),
      state = _a.state,
      dispatch = _a.dispatch;

  var initPlayer$1 = useCallback(function () {
    return initPlayer(dispatch, playerId, false);
  }, [playerId, dispatch]);
  var recreatePlayer = useCallback(function () {
    return initPlayer(dispatch, playerId, true);
  }, [playerId, dispatch]);
  var destroyPlayer$1 = useCallback(function () {
    return destroyPlayer(dispatch, playerId);
  }, [playerId, dispatch]);
  var setLoading$1 = useCallback(function (value) {
    return setLoading(dispatch, playerId, value);
  }, [playerId, dispatch]);
  var setPlaying$1 = useCallback(function (value) {
    return setPlaying(dispatch, playerId, value);
  }, [playerId, dispatch]);
  var setSources$1 = useCallback(function (value) {
    return setSources(dispatch, playerId, value);
  }, [playerId, dispatch]);
  var setActiveSourceId$1 = useCallback(function (value) {
    return setActiveSourceId(dispatch, playerId, value);
  }, [playerId, dispatch]);
  var setVolume$1 = useCallback(function (value) {
    return setVolume(dispatch, playerId, value);
  }, [playerId, dispatch]);
  var setTotalTime$1 = useCallback(function (value) {
    return setTotalTime(dispatch, playerId, value);
  }, [playerId, dispatch]);
  var seek$1 = useCallback(function (value, playOnSeek) {
    seek(dispatch, playerId, value, playOnSeek);
  }, [playerId, dispatch]);
  var load$1 = useCallback(function (value) {
    load(dispatch, playerId, value);
  }, [playerId, dispatch]);
  var setLoop$1 = useCallback(function (value) {
    return setLoop(dispatch, playerId, value);
  }, [playerId, dispatch]);
  return __assign(__assign({
    activePlayerId: state.activePlayerId
  }, getPlayerStateById(state, playerId)), {
    initPlayer: initPlayer$1,
    recreatePlayer: recreatePlayer,
    destroyPlayer: destroyPlayer$1,
    setLoading: setLoading$1,
    setPlaying: setPlaying$1,
    setSources: setSources$1,
    setActiveSourceId: setActiveSourceId$1,
    setVolume: setVolume$1,
    setTotalTime: setTotalTime$1,
    seek: seek$1,
    load: load$1,
    setLoop: setLoop$1
  });
};

var usePlayer = function usePlayer(playerId) {
  var _a = useState(0),
      currentTime = _a[0],
      setCurrentTime = _a[1];

  var _b = useState(false),
      isCurrentTimeAccessed = _b[0],
      setIsCurrentTimeAccessed = _b[1];

  var _c = usePlayerContext(playerId),
      playing = _c.playing,
      loading = _c.loading,
      activeSourceId = _c.activeSourceId,
      totalTime = _c.totalTime,
      sources = _c.sources,
      setPlaying = _c.setPlaying,
      setSources = _c.setSources,
      setActiveSourceId = _c.setActiveSourceId,
      setVolume = _c.setVolume,
      setLoading = _c.setLoading,
      seek = _c.seek,
      initPlayer = _c.initPlayer,
      destroyPlayer = _c.destroyPlayer,
      error = _c.error,
      recreatePlayer = _c.recreatePlayer,
      load = _c.load,
      setLoop = _c.setLoop;

  useEffect(function () {
    initPlayer();
    return destroyPlayer;
  }, [initPlayer, destroyPlayer]);
  useEffect(function () {
    if (playerId && isCurrentTimeAccessed) {
      var unsubscribe = CurrentTimePubSub.getInstance().subscribeToCurrentTime(function (currentTimes) {
        // note: Re-render the current player only
        setCurrentTime(currentTimes[playerId] ? currentTimes[playerId] : 0);
      }).unsubscribe;
      return unsubscribe;
    }
  }, [activeSourceId, playerId, isCurrentTimeAccessed]);
  return new Proxy({
    playing: playing,
    loading: loading,
    activeSourceId: activeSourceId,
    currentTime: currentTime,
    totalTime: totalTime,
    sources: sources,
    setPlaying: setPlaying,
    setSources: setSources,
    setActiveSourceId: setActiveSourceId,
    setVolume: setVolume,
    setLoading: setLoading,
    seek: seek,
    error: error,
    recreatePlayer: recreatePlayer,
    load: load,
    setLoop: setLoop
  }, {
    get: function get(target, key) {
      if (key === 'currentTime' && !isCurrentTimeAccessed) {
        setIsCurrentTimeAccessed(true);
      }

      return target[key];
    }
  });
};

var OverLappingCanvas = styled.canvas(templateObject_1$2 || (templateObject_1$2 = __makeTemplateObject(["\n    position: absolute;\n    left: 0;\n"], ["\n    position: absolute;\n    left: 0;\n"])));
var templateObject_1$2;
var DefaultThemeOriginal = {
  barColor: '#d9d9d9',
  barProgressColor: '#04303e',
  barProgressColorAfterPosition: '#3cc9c9',
  barHoverColor: '#aee9e9',
  playHeadColor: '#32cbcb',
  playHeadTextColor: '#fff',
  playHeadTextOffset: 0,
  animInSpeed: 0,
  animOutSpeed: 0
};
var DefaultThemeMaster = {
  barColor: '#ededed',
  barProgressColor: '#32cbcb',
  barProgressColorAfterPosition: '#aee9e9',
  barHoverColor: '#8ff9f5',
  playHeadColor: '#32cbcb',
  playHeadTextColor: '#fff',
  playHeadTextOffset: 0,
  animInSpeed: 0.5,
  animOutSpeed: 0.5
};
var DefaultTheme = {
  original: DefaultThemeOriginal,
  master: DefaultThemeMaster
};
var DefaultConfig = {
  barWidth: 2,
  barSpacing: 2,
  mirrored: false,
  playOnSeek: true,
  hasPlayhead: false,
  silenceBarHeight: 1
};

var WaveBar =
/** @class */
function () {
  function WaveBar() {
    this.id = 0;
    this.height = 0;
    this.progressHeight = 0;
    this.baseColor = DefaultThemeOriginal.barColor;
    this.progressColor = DefaultThemeOriginal.barProgressColor;
    this.currentColor = DefaultThemeOriginal.barColor;
    this.hoverColor = DefaultThemeOriginal.barHoverColor;
    this.x = 0;
    this.width = 0;
    this.ratioPositionX = 0;
    this.currentProgressPosition = 0;
    this.isProgressStarted = false;
  }

  return WaveBar;
}();

var WaveformDrawer =
/** @class */
function () {
  function WaveformDrawer(canvas, originalDataPoints, masterDataPoints, maxDataPoint, config, requestRender, cancelRender) {
    var _this = this;

    this.originalDataPoints = originalDataPoints;
    this.masterDataPoints = masterDataPoints;
    this.maxDataPoint = maxDataPoint;
    this.config = config;
    this.waveBarItems = [];
    this.animInProgressHeight = 0;
    this.animMaxHeight = 0;
    this.currentProgress = 0;
    this.currentHoverProgress = 0;
    this.hasUpdates = true;
    this.waveformAnimationOut = false;
    this.waveformAnimationIn = false;
    this.previousRenderTimestamps = {
      in: Date.now(),
      out: undefined
    };

    if (!canvas) {
      throw 'Could not initialize WaveformDrawer, canvas is null';
    }

    this.context = canvas.getContext('2d');
    this.initWaveform();

    this.requestRender = function () {
      return requestRender(_this);
    };

    this.destroy = function () {
      return cancelRender(_this);
    };
  }

  WaveformDrawer.prototype.updateProgress = function (currentTime, totalTime) {
    this.currentProgress = currentTime / totalTime;
    this.requestRender();
  };

  WaveformDrawer.prototype.updateHoverProgress = function (ratio) {
    this.currentHoverProgress = ratio;
    this.requestRender();
  };

  WaveformDrawer.prototype.clearBar = function () {
    this.waveBarItems = [];
    this.context.clearRect(0, 0, this.config.canvasWidth, this.config.canvasHeight);
    this.context.restore();
  };

  WaveformDrawer.prototype.changeMasterData = function (newData) {
    var effectiveHeight = this.config.canvasHeight;

    for (var i = 0; i < this.waveBarItems.length; i++) {
      if (this.masterDataPoints.length > 1) {
        var diff = this.originalDataPoints[i] + newData[i];
        this.waveBarItems[i].height = Math.round(diff * effectiveHeight) || this.config.silenceBarHeight;
      } else {
        this.waveBarItems[i].height = Math.round(newData[i] * effectiveHeight) || this.config.silenceBarHeight;
      }
    }
  };

  WaveformDrawer.prototype.update = function () {
    if (this.waveformAnimationIn) {
      var delta = this.getTimeDelta('in');
      var heightStep = Math.round(this.animMaxHeight * delta / (this.config.animInSpeed * 1000));
      this.animInProgressHeight = Math.min(this.animInProgressHeight + heightStep, this.animMaxHeight); // TODO: animIn bar to bar from left to right and find a way to increment the speed with smaller value

      for (var i = 0; i < this.waveBarItems.length; i++) {
        if (this.waveBarItems[i].progressHeight <= this.waveBarItems[i].height) {
          this.drawWaveBar(this.waveBarItems[i], Math.min(this.animInProgressHeight, this.waveBarItems[i].height));
        }
      }

      if (this.animInProgressHeight >= this.animMaxHeight) {
        this.waveformAnimationIn = false;
        this.animInProgressHeight = 0;
      } else {
        this.requestRender();
      }
    } else if (this.waveformAnimationOut) {
      var animOutMaxHeight = 0;
      var delta = this.getTimeDelta('out');
      this.context.clearRect(0, 0, this.config.canvasWidth, this.config.canvasHeight);
      this.context.restore();
      var heightStep = Math.round(this.animMaxHeight * delta / (this.config.animOutSpeed * 1000));

      for (var i = 0; i < this.waveBarItems.length; i++) {
        var newHeight = Math.max(this.waveBarItems[i].progressHeight - heightStep, 0);

        if (animOutMaxHeight < newHeight) {
          animOutMaxHeight = newHeight;
        }

        if (newHeight >= 0) {
          this.drawWaveBar(this.waveBarItems[i], newHeight);
        }
      }

      if (animOutMaxHeight <= 0) {
        this.destroy();
      } else {
        this.requestRender();
      }
    } else if (this.hasUpdates) {
      // WATCH PROGRESS-HOVER-SEEK AND UPDATE BAR COLORS
      this.context.clearRect(0, 0, this.config.canvasWidth, this.config.canvasHeight);
      this.context.restore();

      for (var i = 0; i < this.waveBarItems.length; i++) {
        this.drawWaveBar(this.waveBarItems[i], this.waveBarItems[i].height);
      }
    }
  };
  /**
   *  Set each waveBar of the waveform with it initial proprieties
   **/


  WaveformDrawer.prototype.initWaveform = function () {
    var _this = this;

    var maxHeightCoefficient = this.config.canvasHeight / this.maxDataPoint;
    this.originalDataPoints.forEach(function (value, i) {
      var x = 1 + i * (_this.config.barWidth + _this.config.barSpacing);
      var waveBar = new WaveBar();

      if (_this.masterDataPoints.length > 1) {
        var diff = value + _this.masterDataPoints[i];
        waveBar.height = Math.round(diff * maxHeightCoefficient) || _this.config.silenceBarHeight;
      } else {
        waveBar.height = Math.round(value * maxHeightCoefficient) || _this.config.silenceBarHeight;
      }

      waveBar.baseColor = _this.config.barColor;
      waveBar.progressColor = _this.config.barProgressColor;
      waveBar.currentColor = _this.config.barColor;
      waveBar.hoverColor = _this.config.barHoverColor;

      if (waveBar.height > _this.animMaxHeight) {
        _this.animMaxHeight = waveBar.height;
      }

      waveBar.id = i;
      waveBar.x = Math.floor(x);
      waveBar.width = _this.config.barWidth;
      waveBar.progressHeight = 0;

      _this.waveBarItems.push(waveBar);

      _this.drawWaveBar(waveBar, 0);
    });

    if (this.config.animInSpeed > 0) {
      this.waveformAnimationIn = true;
    }
  };
  /**
   * Update the height or the color of each waveBar from the requestAnimationFrame() to update the waveForm canvas.
   **/


  WaveformDrawer.prototype.drawWaveBar = function (waveBar, currentHeight) {
    this.context.translate(0.5, 0.5);

    for (var i = 0; i < waveBar.width; i++) {
      var x = Math.floor(waveBar.x) + i + 0.5;
      var y = this.config.mirrored ? (this.config.canvasHeight - currentHeight) / 2 : 0;
      y = Math.floor(y) + 0.5;
      this.context.fillStyle = this.getBarColor(x);
      this.context.fillRect(x, y, 1, currentHeight);
      waveBar.progressHeight = currentHeight;
    }

    this.context.translate(-0.5, -0.5);
  };

  WaveformDrawer.prototype.getBarColor = function (x) {
    var ratioPositionX = x / this.config.canvasWidth; // Bar is in progress

    if (ratioPositionX <= this.currentProgress) {
      // Bar is after hover
      if (this.currentHoverProgress > 0 && ratioPositionX >= this.currentHoverProgress) {
        // Bar is hover after progress
        return this.config.barProgressColorAfterPosition;
      }

      return this.config.barProgressColor;
    } else {
      // Bar not in progress
      if (ratioPositionX <= this.currentHoverProgress) {
        // Bar is before hover
        return this.config.barHoverColor;
      }

      return this.config.barColor;
    }
  };

  WaveformDrawer.prototype.getTimeDelta = function (type) {
    var now = Date.now();
    var delta = now - (this.previousRenderTimestamps[type] || now);
    this.previousRenderTimestamps[type] = now;
    return delta;
  };

  return WaveformDrawer;
}();

function initCanvasContext(canvas, width, height) {
  if (!canvas) {
    return;
  } // devicePixelRatio to draw clear edges for high DPI devices like retina display


  var ratio = Math.ceil(devicePixelRatio || 1);
  var roundedWidth = Math.round(width);
  canvas.height = height * ratio;
  canvas.width = roundedWidth * ratio;
  var ctx = canvas.getContext('2d');
  ctx.setTransform(ratio, 0, 0, -ratio, 0, height * ratio);
  canvas.style.width = roundedWidth + "px";
  canvas.style.height = height + "px";
}

function cosineInterpolate(y1, y2, mu) {
  var mu2 = (1 - Math.cos(mu * Math.PI)) / 2;
  return y1 * (1 - mu2) + y2 * mu2;
}
/**
 * Converts the data array into an array with `totalNbPoints` length.
 * We're using cosine interpolation to deduce the intermediate data points
 */


function getInterpolatedDataPoints(totalNbPoints, data) {
  if (!data || data.length === 0) {
    return data;
  }

  var dataPoints = [];
  var ratio = data.length / totalNbPoints;

  for (var i = 0; i < totalNbPoints; i++) {
    var x = i * ratio;
    var x1 = Math.floor(x);
    var x2 = x1 + 1;
    dataPoints.push(cosineInterpolate(data[x1], data[x2] || data[x1], x - x1));
  }

  return dataPoints;
}

function calculateMaxDataPoint(dataPoints) {
  var maxMasterDataPoints = dataPoints.differences.map(function (difference) {
    return Math.max.apply(null, difference.value.map(function (difference, index) {
      var _a;

      return ((_a = dataPoints.original.value[index]) !== null && _a !== void 0 ? _a : 0) + difference;
    }));
  });
  return Math.max.apply(null, __spreadArray(__spreadArray([], dataPoints.original.value, true), maxMasterDataPoints, true));
}
/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */

/* eslint-disable require-jsdoc, valid-jsdoc */


var MapShim = function () {
  if (typeof Map !== 'undefined') {
    return Map;
  }
  /**
   * Returns index in provided array that matches the specified key.
   *
   * @param {Array<Array>} arr
   * @param {*} key
   * @returns {number}
   */


  function getIndex(arr, key) {
    var result = -1;
    arr.some(function (entry, index) {
      if (entry[0] === key) {
        result = index;
        return true;
      }

      return false;
    });
    return result;
  }

  return (
    /** @class */
    function () {
      function class_1() {
        this.__entries__ = [];
      }

      Object.defineProperty(class_1.prototype, "size", {
        /**
         * @returns {boolean}
         */
        get: function get() {
          return this.__entries__.length;
        },
        enumerable: true,
        configurable: true
      });
      /**
       * @param {*} key
       * @returns {*}
       */

      class_1.prototype.get = function (key) {
        var index = getIndex(this.__entries__, key);
        var entry = this.__entries__[index];
        return entry && entry[1];
      };
      /**
       * @param {*} key
       * @param {*} value
       * @returns {void}
       */


      class_1.prototype.set = function (key, value) {
        var index = getIndex(this.__entries__, key);

        if (~index) {
          this.__entries__[index][1] = value;
        } else {
          this.__entries__.push([key, value]);
        }
      };
      /**
       * @param {*} key
       * @returns {void}
       */


      class_1.prototype.delete = function (key) {
        var entries = this.__entries__;
        var index = getIndex(entries, key);

        if (~index) {
          entries.splice(index, 1);
        }
      };
      /**
       * @param {*} key
       * @returns {void}
       */


      class_1.prototype.has = function (key) {
        return !!~getIndex(this.__entries__, key);
      };
      /**
       * @returns {void}
       */


      class_1.prototype.clear = function () {
        this.__entries__.splice(0);
      };
      /**
       * @param {Function} callback
       * @param {*} [ctx=null]
       * @returns {void}
       */


      class_1.prototype.forEach = function (callback, ctx) {
        if (ctx === void 0) {
          ctx = null;
        }

        for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
          var entry = _a[_i];
          callback.call(ctx, entry[1], entry[0]);
        }
      };

      return class_1;
    }()
  );
}();
/**
 * Detects whether window and document objects are available in current environment.
 */


var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document; // Returns global object of a current environment.

var global$1 = function () {
  if (typeof global !== 'undefined' && global.Math === Math) {
    return global;
  }

  if (typeof self !== 'undefined' && self.Math === Math) {
    return self;
  }

  if (typeof window !== 'undefined' && window.Math === Math) {
    return window;
  } // eslint-disable-next-line no-new-func


  return Function('return this')();
}();
/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */


var requestAnimationFrame$1 = function () {
  if (typeof requestAnimationFrame === 'function') {
    // It's required to use a bounded function because IE sometimes throws
    // an "Invalid calling object" error if rAF is invoked without the global
    // object on the left hand side.
    return requestAnimationFrame.bind(global$1);
  }

  return function (callback) {
    return setTimeout(function () {
      return callback(Date.now());
    }, 1000 / 60);
  };
}(); // Defines minimum timeout before adding a trailing call.


var trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */

function throttle(callback, delay) {
  var leadingCall = false,
      trailingCall = false,
      lastCallTime = 0;
  /**
   * Invokes the original callback function and schedules new invocation if
   * the "proxy" was called during current request.
   *
   * @returns {void}
   */

  function resolvePending() {
    if (leadingCall) {
      leadingCall = false;
      callback();
    }

    if (trailingCall) {
      proxy();
    }
  }
  /**
   * Callback invoked after the specified delay. It will further postpone
   * invocation of the original function delegating it to the
   * requestAnimationFrame.
   *
   * @returns {void}
   */


  function timeoutCallback() {
    requestAnimationFrame$1(resolvePending);
  }
  /**
   * Schedules invocation of the original function.
   *
   * @returns {void}
   */


  function proxy() {
    var timeStamp = Date.now();

    if (leadingCall) {
      // Reject immediately following calls.
      if (timeStamp - lastCallTime < trailingTimeout) {
        return;
      } // Schedule new call to be in invoked when the pending one is resolved.
      // This is important for "transitions" which never actually start
      // immediately so there is a chance that we might miss one if change
      // happens amids the pending invocation.


      trailingCall = true;
    } else {
      leadingCall = true;
      trailingCall = false;
      setTimeout(timeoutCallback, delay);
    }

    lastCallTime = timeStamp;
  }

  return proxy;
} // Minimum delay before invoking the update of observers.


var REFRESH_DELAY = 20; // A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.

var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight']; // Check if MutationObserver is available.

var mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */

var ResizeObserverController =
/** @class */
function () {
  /**
   * Creates a new instance of ResizeObserverController.
   *
   * @private
   */
  function ResizeObserverController() {
    /**
     * Indicates whether DOM listeners have been added.
     *
     * @private {boolean}
     */
    this.connected_ = false;
    /**
     * Tells that controller has subscribed for Mutation Events.
     *
     * @private {boolean}
     */

    this.mutationEventsAdded_ = false;
    /**
     * Keeps reference to the instance of MutationObserver.
     *
     * @private {MutationObserver}
     */

    this.mutationsObserver_ = null;
    /**
     * A list of connected observers.
     *
     * @private {Array<ResizeObserverSPI>}
     */

    this.observers_ = [];
    this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
    this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
  }
  /**
   * Adds observer to observers list.
   *
   * @param {ResizeObserverSPI} observer - Observer to be added.
   * @returns {void}
   */


  ResizeObserverController.prototype.addObserver = function (observer) {
    if (!~this.observers_.indexOf(observer)) {
      this.observers_.push(observer);
    } // Add listeners if they haven't been added yet.


    if (!this.connected_) {
      this.connect_();
    }
  };
  /**
   * Removes observer from observers list.
   *
   * @param {ResizeObserverSPI} observer - Observer to be removed.
   * @returns {void}
   */


  ResizeObserverController.prototype.removeObserver = function (observer) {
    var observers = this.observers_;
    var index = observers.indexOf(observer); // Remove observer if it's present in registry.

    if (~index) {
      observers.splice(index, 1);
    } // Remove listeners if controller has no connected observers.


    if (!observers.length && this.connected_) {
      this.disconnect_();
    }
  };
  /**
   * Invokes the update of observers. It will continue running updates insofar
   * it detects changes.
   *
   * @returns {void}
   */


  ResizeObserverController.prototype.refresh = function () {
    var changesDetected = this.updateObservers_(); // Continue running updates if changes have been detected as there might
    // be future ones caused by CSS transitions.

    if (changesDetected) {
      this.refresh();
    }
  };
  /**
   * Updates every observer from observers list and notifies them of queued
   * entries.
   *
   * @private
   * @returns {boolean} Returns "true" if any observer has detected changes in
   *      dimensions of it's elements.
   */


  ResizeObserverController.prototype.updateObservers_ = function () {
    // Collect observers that have active observations.
    var activeObservers = this.observers_.filter(function (observer) {
      return observer.gatherActive(), observer.hasActive();
    }); // Deliver notifications in a separate cycle in order to avoid any
    // collisions between observers, e.g. when multiple instances of
    // ResizeObserver are tracking the same element and the callback of one
    // of them changes content dimensions of the observed target. Sometimes
    // this may result in notifications being blocked for the rest of observers.

    activeObservers.forEach(function (observer) {
      return observer.broadcastActive();
    });
    return activeObservers.length > 0;
  };
  /**
   * Initializes DOM listeners.
   *
   * @private
   * @returns {void}
   */


  ResizeObserverController.prototype.connect_ = function () {
    // Do nothing if running in a non-browser environment or if listeners
    // have been already added.
    if (!isBrowser || this.connected_) {
      return;
    } // Subscription to the "Transitionend" event is used as a workaround for
    // delayed transitions. This way it's possible to capture at least the
    // final state of an element.


    document.addEventListener('transitionend', this.onTransitionEnd_);
    window.addEventListener('resize', this.refresh);

    if (mutationObserverSupported) {
      this.mutationsObserver_ = new MutationObserver(this.refresh);
      this.mutationsObserver_.observe(document, {
        attributes: true,
        childList: true,
        characterData: true,
        subtree: true
      });
    } else {
      document.addEventListener('DOMSubtreeModified', this.refresh);
      this.mutationEventsAdded_ = true;
    }

    this.connected_ = true;
  };
  /**
   * Removes DOM listeners.
   *
   * @private
   * @returns {void}
   */


  ResizeObserverController.prototype.disconnect_ = function () {
    // Do nothing if running in a non-browser environment or if listeners
    // have been already removed.
    if (!isBrowser || !this.connected_) {
      return;
    }

    document.removeEventListener('transitionend', this.onTransitionEnd_);
    window.removeEventListener('resize', this.refresh);

    if (this.mutationsObserver_) {
      this.mutationsObserver_.disconnect();
    }

    if (this.mutationEventsAdded_) {
      document.removeEventListener('DOMSubtreeModified', this.refresh);
    }

    this.mutationsObserver_ = null;
    this.mutationEventsAdded_ = false;
    this.connected_ = false;
  };
  /**
   * "Transitionend" event handler.
   *
   * @private
   * @param {TransitionEvent} event
   * @returns {void}
   */


  ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
    var _b = _a.propertyName,
        propertyName = _b === void 0 ? '' : _b; // Detect whether transition may affect dimensions of an element.

    var isReflowProperty = transitionKeys.some(function (key) {
      return !!~propertyName.indexOf(key);
    });

    if (isReflowProperty) {
      this.refresh();
    }
  };
  /**
   * Returns instance of the ResizeObserverController.
   *
   * @returns {ResizeObserverController}
   */


  ResizeObserverController.getInstance = function () {
    if (!this.instance_) {
      this.instance_ = new ResizeObserverController();
    }

    return this.instance_;
  };
  /**
   * Holds reference to the controller's instance.
   *
   * @private {ResizeObserverController}
   */


  ResizeObserverController.instance_ = null;
  return ResizeObserverController;
}();
/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */


var defineConfigurable = function defineConfigurable(target, props) {
  for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
    var key = _a[_i];
    Object.defineProperty(target, key, {
      value: props[key],
      enumerable: false,
      writable: false,
      configurable: true
    });
  }

  return target;
};
/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */


var getWindowOf = function getWindowOf(target) {
  // Assume that the element is an instance of Node, which means that it
  // has the "ownerDocument" property from which we can retrieve a
  // corresponding global object.
  var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView; // Return the local global object if it's not possible extract one from
  // provided element.

  return ownerGlobal || global$1;
}; // Placeholder of an empty content rectangle.


var emptyRect = createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */

function toFloat(value) {
  return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */


function getBordersSize(styles) {
  var positions = [];

  for (var _i = 1; _i < arguments.length; _i++) {
    positions[_i - 1] = arguments[_i];
  }

  return positions.reduce(function (size, position) {
    var value = styles['border-' + position + '-width'];
    return size + toFloat(value);
  }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */


function getPaddings(styles) {
  var positions = ['top', 'right', 'bottom', 'left'];
  var paddings = {};

  for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
    var position = positions_1[_i];
    var value = styles['padding-' + position];
    paddings[position] = toFloat(value);
  }

  return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */


function getSVGContentRect(target) {
  var bbox = target.getBBox();
  return createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */


function getHTMLElementContentRect(target) {
  // Client width & height properties can't be
  // used exclusively as they provide rounded values.
  var clientWidth = target.clientWidth,
      clientHeight = target.clientHeight; // By this condition we can catch all non-replaced inline, hidden and
  // detached elements. Though elements with width & height properties less
  // than 0.5 will be discarded as well.
  //
  // Without it we would need to implement separate methods for each of
  // those cases and it's not possible to perform a precise and performance
  // effective test for hidden elements. E.g. even jQuery's ':visible' filter
  // gives wrong results for elements with width & height less than 0.5.

  if (!clientWidth && !clientHeight) {
    return emptyRect;
  }

  var styles = getWindowOf(target).getComputedStyle(target);
  var paddings = getPaddings(styles);
  var horizPad = paddings.left + paddings.right;
  var vertPad = paddings.top + paddings.bottom; // Computed styles of width & height are being used because they are the
  // only dimensions available to JS that contain non-rounded values. It could
  // be possible to utilize the getBoundingClientRect if only it's data wasn't
  // affected by CSS transformations let alone paddings, borders and scroll bars.

  var width = toFloat(styles.width),
      height = toFloat(styles.height); // Width & height include paddings and borders when the 'border-box' box
  // model is applied (except for IE).

  if (styles.boxSizing === 'border-box') {
    // Following conditions are required to handle Internet Explorer which
    // doesn't include paddings and borders to computed CSS dimensions.
    //
    // We can say that if CSS dimensions + paddings are equal to the "client"
    // properties then it's either IE, and thus we don't need to subtract
    // anything, or an element merely doesn't have paddings/borders styles.
    if (Math.round(width + horizPad) !== clientWidth) {
      width -= getBordersSize(styles, 'left', 'right') + horizPad;
    }

    if (Math.round(height + vertPad) !== clientHeight) {
      height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
    }
  } // Following steps can't be applied to the document's root element as its
  // client[Width/Height] properties represent viewport area of the window.
  // Besides, it's as well not necessary as the <html> itself neither has
  // rendered scroll bars nor it can be clipped.


  if (!isDocumentElement(target)) {
    // In some browsers (only in Firefox, actually) CSS width & height
    // include scroll bars size which can be removed at this step as scroll
    // bars are the only difference between rounded dimensions + paddings
    // and "client" properties, though that is not always true in Chrome.
    var vertScrollbar = Math.round(width + horizPad) - clientWidth;
    var horizScrollbar = Math.round(height + vertPad) - clientHeight; // Chrome has a rather weird rounding of "client" properties.
    // E.g. for an element with content width of 314.2px it sometimes gives
    // the client width of 315px and for the width of 314.7px it may give
    // 314px. And it doesn't happen all the time. So just ignore this delta
    // as a non-relevant.

    if (Math.abs(vertScrollbar) !== 1) {
      width -= vertScrollbar;
    }

    if (Math.abs(horizScrollbar) !== 1) {
      height -= horizScrollbar;
    }
  }

  return createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */


var isSVGGraphicsElement = function () {
  // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
  // interface.
  if (typeof SVGGraphicsElement !== 'undefined') {
    return function (target) {
      return target instanceof getWindowOf(target).SVGGraphicsElement;
    };
  } // If it's so, then check that element is at least an instance of the
  // SVGElement and that it has the "getBBox" method.
  // eslint-disable-next-line no-extra-parens


  return function (target) {
    return target instanceof getWindowOf(target).SVGElement && typeof target.getBBox === 'function';
  };
}();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */


function isDocumentElement(target) {
  return target === getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */


function getContentRect(target) {
  if (!isBrowser) {
    return emptyRect;
  }

  if (isSVGGraphicsElement(target)) {
    return getSVGContentRect(target);
  }

  return getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */


function createReadOnlyRect(_a) {
  var x = _a.x,
      y = _a.y,
      width = _a.width,
      height = _a.height; // If DOMRectReadOnly is available use it as a prototype for the rectangle.

  var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
  var rect = Object.create(Constr.prototype); // Rectangle's properties are not writable and non-enumerable.

  defineConfigurable(rect, {
    x: x,
    y: y,
    width: width,
    height: height,
    top: y,
    right: x + width,
    bottom: height + y,
    left: x
  });
  return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */


function createRectInit(x, y, width, height) {
  return {
    x: x,
    y: y,
    width: width,
    height: height
  };
}
/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */


var ResizeObservation =
/** @class */
function () {
  /**
   * Creates an instance of ResizeObservation.
   *
   * @param {Element} target - Element to be observed.
   */
  function ResizeObservation(target) {
    /**
     * Broadcasted width of content rectangle.
     *
     * @type {number}
     */
    this.broadcastWidth = 0;
    /**
     * Broadcasted height of content rectangle.
     *
     * @type {number}
     */

    this.broadcastHeight = 0;
    /**
     * Reference to the last observed content rectangle.
     *
     * @private {DOMRectInit}
     */

    this.contentRect_ = createRectInit(0, 0, 0, 0);
    this.target = target;
  }
  /**
   * Updates content rectangle and tells whether it's width or height properties
   * have changed since the last broadcast.
   *
   * @returns {boolean}
   */


  ResizeObservation.prototype.isActive = function () {
    var rect = getContentRect(this.target);
    this.contentRect_ = rect;
    return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
  };
  /**
   * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
   * from the corresponding properties of the last observed content rectangle.
   *
   * @returns {DOMRectInit} Last observed content rectangle.
   */


  ResizeObservation.prototype.broadcastRect = function () {
    var rect = this.contentRect_;
    this.broadcastWidth = rect.width;
    this.broadcastHeight = rect.height;
    return rect;
  };

  return ResizeObservation;
}();

var ResizeObserverEntry =
/** @class */
function () {
  /**
   * Creates an instance of ResizeObserverEntry.
   *
   * @param {Element} target - Element that is being observed.
   * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
   */
  function ResizeObserverEntry(target, rectInit) {
    var contentRect = createReadOnlyRect(rectInit); // According to the specification following properties are not writable
    // and are also not enumerable in the native implementation.
    //
    // Property accessors are not being used as they'd require to define a
    // private WeakMap storage which may cause memory leaks in browsers that
    // don't support this type of collections.

    defineConfigurable(this, {
      target: target,
      contentRect: contentRect
    });
  }

  return ResizeObserverEntry;
}();

var ResizeObserverSPI =
/** @class */
function () {
  /**
   * Creates a new instance of ResizeObserver.
   *
   * @param {ResizeObserverCallback} callback - Callback function that is invoked
   *      when one of the observed elements changes it's content dimensions.
   * @param {ResizeObserverController} controller - Controller instance which
   *      is responsible for the updates of observer.
   * @param {ResizeObserver} callbackCtx - Reference to the public
   *      ResizeObserver instance which will be passed to callback function.
   */
  function ResizeObserverSPI(callback, controller, callbackCtx) {
    /**
     * Collection of resize observations that have detected changes in dimensions
     * of elements.
     *
     * @private {Array<ResizeObservation>}
     */
    this.activeObservations_ = [];
    /**
     * Registry of the ResizeObservation instances.
     *
     * @private {Map<Element, ResizeObservation>}
     */

    this.observations_ = new MapShim();

    if (typeof callback !== 'function') {
      throw new TypeError('The callback provided as parameter 1 is not a function.');
    }

    this.callback_ = callback;
    this.controller_ = controller;
    this.callbackCtx_ = callbackCtx;
  }
  /**
   * Starts observing provided element.
   *
   * @param {Element} target - Element to be observed.
   * @returns {void}
   */


  ResizeObserverSPI.prototype.observe = function (target) {
    if (!arguments.length) {
      throw new TypeError('1 argument required, but only 0 present.');
    } // Do nothing if current environment doesn't have the Element interface.


    if (typeof Element === 'undefined' || !(Element instanceof Object)) {
      return;
    }

    if (!(target instanceof getWindowOf(target).Element)) {
      throw new TypeError('parameter 1 is not of type "Element".');
    }

    var observations = this.observations_; // Do nothing if element is already being observed.

    if (observations.has(target)) {
      return;
    }

    observations.set(target, new ResizeObservation(target));
    this.controller_.addObserver(this); // Force the update of observations.

    this.controller_.refresh();
  };
  /**
   * Stops observing provided element.
   *
   * @param {Element} target - Element to stop observing.
   * @returns {void}
   */


  ResizeObserverSPI.prototype.unobserve = function (target) {
    if (!arguments.length) {
      throw new TypeError('1 argument required, but only 0 present.');
    } // Do nothing if current environment doesn't have the Element interface.


    if (typeof Element === 'undefined' || !(Element instanceof Object)) {
      return;
    }

    if (!(target instanceof getWindowOf(target).Element)) {
      throw new TypeError('parameter 1 is not of type "Element".');
    }

    var observations = this.observations_; // Do nothing if element is not being observed.

    if (!observations.has(target)) {
      return;
    }

    observations.delete(target);

    if (!observations.size) {
      this.controller_.removeObserver(this);
    }
  };
  /**
   * Stops observing all elements.
   *
   * @returns {void}
   */


  ResizeObserverSPI.prototype.disconnect = function () {
    this.clearActive();
    this.observations_.clear();
    this.controller_.removeObserver(this);
  };
  /**
   * Collects observation instances the associated element of which has changed
   * it's content rectangle.
   *
   * @returns {void}
   */


  ResizeObserverSPI.prototype.gatherActive = function () {
    var _this = this;

    this.clearActive();
    this.observations_.forEach(function (observation) {
      if (observation.isActive()) {
        _this.activeObservations_.push(observation);
      }
    });
  };
  /**
   * Invokes initial callback function with a list of ResizeObserverEntry
   * instances collected from active resize observations.
   *
   * @returns {void}
   */


  ResizeObserverSPI.prototype.broadcastActive = function () {
    // Do nothing if observer doesn't have active observations.
    if (!this.hasActive()) {
      return;
    }

    var ctx = this.callbackCtx_; // Create ResizeObserverEntry instance for every active observation.

    var entries = this.activeObservations_.map(function (observation) {
      return new ResizeObserverEntry(observation.target, observation.broadcastRect());
    });
    this.callback_.call(ctx, entries, ctx);
    this.clearActive();
  };
  /**
   * Clears the collection of active observations.
   *
   * @returns {void}
   */


  ResizeObserverSPI.prototype.clearActive = function () {
    this.activeObservations_.splice(0);
  };
  /**
   * Tells whether observer has active observations.
   *
   * @returns {boolean}
   */


  ResizeObserverSPI.prototype.hasActive = function () {
    return this.activeObservations_.length > 0;
  };

  return ResizeObserverSPI;
}(); // Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.


var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */

var ResizeObserver =
/** @class */
function () {
  /**
   * Creates a new instance of ResizeObserver.
   *
   * @param {ResizeObserverCallback} callback - Callback that is invoked when
   *      dimensions of the observed elements change.
   */
  function ResizeObserver(callback) {
    if (!(this instanceof ResizeObserver)) {
      throw new TypeError('Cannot call a class as a function.');
    }

    if (!arguments.length) {
      throw new TypeError('1 argument required, but only 0 present.');
    }

    var controller = ResizeObserverController.getInstance();
    var observer = new ResizeObserverSPI(callback, controller, this);
    observers.set(this, observer);
  }

  return ResizeObserver;
}(); // Expose public methods of ResizeObserver.


['observe', 'unobserve', 'disconnect'].forEach(function (method) {
  ResizeObserver.prototype[method] = function () {
    var _a;

    return (_a = observers.get(this))[method].apply(_a, arguments);
  };
});

var index = function () {
  // Export existing implementation if available.
  if (typeof global$1.ResizeObserver !== 'undefined') {
    return global$1.ResizeObserver;
  }

  return ResizeObserver;
}();
/**
 * Taken from the following gist but we've removed ResizeObserver which is experimental and there is no type
 * https://gist.github.com/morajabi/523d7a642d8c0a2f71fcfa0d8b3d2846
 */


function getRect(element) {
  if (!element) {
    return {
      bottom: 0,
      height: 0,
      left: 0,
      right: 0,
      top: 0,
      width: 0,
      x: 0,
      y: 0,
      toJSON: function toJSON() {
        return;
      }
    };
  }

  return element.getBoundingClientRect();
}
/**
 * Returns element measurements by running element.getBoundingClientRect().
 *
 * @param ref ref of the element to get measurements.
 * @param isResizable enable ResizeObserver on ref.current
 * Default value is `false`.
 */


var useBoundingClientRect = function useBoundingClientRect(ref, isResizable) {
  if (isResizable === void 0) {
    isResizable = false;
  }

  var _a = useState(function () {
    return getRect(ref ? ref.current : null);
  }),
      rect = _a[0],
      setRect = _a[1];

  useEnhancedEffect(function () {
    var handleResize = function handleResize() {
      return setRect(getRect(ref.current));
    };

    handleResize();

    if (isResizable) {
      var handleResizeDebounced = debounce(handleResize, 125, {
        leading: false,
        trailing: true,
        maxWait: 5000
      });
      var resizeObserver_1 = new index(handleResizeDebounced);
      ref.current && resizeObserver_1.observe(ref.current);
      return function () {
        ref.current && resizeObserver_1.unobserve(ref.current);
      };
    }
  }, [setRect, isResizable]);
  return rect;
};
/**
 * Calculates the size of the waveform and return a ClientRect object.
 * When the width is updated, we call `onRecommendedCountOfPoints` to request a different number of points
 * @param parentEl
 * @param config
 * @param onRecommendedCountOfPoints
 */


var useWaveformSize = function useWaveformSize(_a) {
  var parentEl = _a.parentEl,
      barWidth = _a.barWidth,
      barSpacing = _a.barSpacing,
      recalculateDataPoints = _a.recalculateDataPoints,
      isResizable = _a.isResizable;
  var parentClientRect = useBoundingClientRect(parentEl, isResizable);
  useEffect(function () {
    var newNbPoints = Math.floor(parentClientRect.width / (barWidth + barSpacing));

    if (newNbPoints > 0) {
      recalculateDataPoints(newNbPoints);
    }
  }, [parentClientRect.width, barWidth, barSpacing, recalculateDataPoints]);
  return parentClientRect;
};

var useWaveform = function useWaveform(_a) {
  var dataPoints = _a.dataPoints,
      currentTime = _a.currentTime,
      totalTime = _a.totalTime,
      configOverride = _a.configOverride,
      themeOverride = _a.themeOverride,
      hoverRatio = _a.hoverRatio,
      isResizable = _a.isResizable,
      masterDiffValue = _a.masterDiffValue;
  var parentEl = useRef(null);
  var waveformCanvas = useRef(null);
  var outAnimationCanvas = useRef(null);
  var waveformContext = useContext(PlayerWaveformContext);

  var _b = useState(),
      drawer = _b[0],
      setDrawer = _b[1];

  var _c = useState([]),
      interpolatedDataPoints = _c[0],
      setInterpolatedDataPoints = _c[1];

  var _d = useState([]),
      interpolatedMasterDiff = _d[0],
      setInterpolatedMasterDiff = _d[1];

  var recalculateDataPoints = useCallback(function (nbPoints) {
    var _a, _b;

    var interpolatedDataPoints = (_a = getInterpolatedDataPoints(nbPoints, dataPoints === null || dataPoints === void 0 ? void 0 : dataPoints.original.value)) !== null && _a !== void 0 ? _a : [];
    var interpolatedMasterDiff = (_b = getInterpolatedDataPoints(nbPoints, masterDiffValue)) !== null && _b !== void 0 ? _b : [];
    setInterpolatedDataPoints(interpolatedDataPoints);
    setInterpolatedMasterDiff(interpolatedMasterDiff);
  }, [dataPoints, JSON.stringify(masterDiffValue)]);
  var maxDataPoint = useMemo(function () {
    return dataPoints ? calculateMaxDataPoint(dataPoints) : 0;
  }, [dataPoints]);
  var config = useMemo(function () {
    return __assign(__assign({}, DefaultConfig), configOverride);
  }, [configOverride]);
  var theme = useMemo(function () {
    return __assign(__assign({}, DefaultThemeOriginal), themeOverride);
  }, [themeOverride]);
  var waveformClientRect = useWaveformSize({
    parentEl: parentEl,
    barWidth: config.barWidth,
    barSpacing: config.barSpacing,
    recalculateDataPoints: recalculateDataPoints,
    isResizable: isResizable
  }); // Setup Waveform drawer

  useEffect(function () {
    var _a;

    if (!interpolatedDataPoints || !maxDataPoint) {
      return;
    }

    var baseConfig = {
      barWidth: config.barWidth,
      barSpacing: config.barSpacing,
      silenceBarHeight: config.silenceBarHeight,
      canvasWidth: waveformClientRect.width,
      canvasHeight: waveformClientRect.height,
      mirrored: config.mirrored
    };
    var newDrawer = new WaveformDrawer(waveformCanvas.current, interpolatedDataPoints, interpolatedMasterDiff || [], maxDataPoint, __assign(__assign({}, baseConfig), theme), waveformContext.requestRender, waveformContext.cancelRender);

    if (drawer) {
      var context = (_a = outAnimationCanvas.current) === null || _a === void 0 ? void 0 : _a.getContext('2d');

      if (context) {
        drawer.context = context;
        drawer.waveformAnimationOut = true;
        drawer.requestRender();
      } else {
        drawer.destroy();
      }
    }

    setDrawer(newDrawer);
  }, [interpolatedDataPoints, interpolatedMasterDiff, maxDataPoint, config, theme, waveformContext.requestRender]); // Draw Progress

  useEffect(function () {
    drawer && drawer.updateProgress(currentTime, totalTime);
  }, [currentTime, totalTime, drawer]); // Draw Hover

  useEffect(function () {
    drawer && drawer.updateHoverProgress(hoverRatio);
  }, [hoverRatio, drawer, waveformClientRect]); // Update canvas

  useEffect(function () {
    initCanvasContext(waveformCanvas.current, waveformClientRect.width, waveformClientRect.height);
    initCanvasContext(outAnimationCanvas.current, waveformClientRect.width, waveformClientRect.height);
    drawer && drawer.requestRender();
  }, [waveformClientRect.width, waveformClientRect.height, drawer]);
  return {
    parentEl: parentEl,
    waveformCanvas: waveformCanvas,
    theme: theme,
    outAnimationCanvas: outAnimationCanvas
  };
};

var Waveform = function Waveform(_a) {
  var dataPoints = _a.dataPoints,
      currentTime = _a.currentTime,
      totalTime = _a.totalTime,
      testId = _a.testId,
      configOverride = _a.config,
      themeOverride = _a.theme,
      _b = _a.isResizable,
      isResizable = _b === void 0 ? true : _b,
      _c = _a.hoverRatio,
      hoverRatio = _c === void 0 ? 0 : _c,
      _d = _a.masterDiffValue,
      masterDiffValue = _d === void 0 ? [] : _d;

  var _e = useWaveform({
    dataPoints: dataPoints,
    currentTime: currentTime,
    totalTime: totalTime,
    configOverride: configOverride,
    themeOverride: themeOverride,
    isResizable: isResizable,
    hoverRatio: hoverRatio,
    masterDiffValue: masterDiffValue
  }),
      parentEl = _e.parentEl,
      waveformCanvas = _e.waveformCanvas,
      theme = _e.theme,
      outAnimationCanvas = _e.outAnimationCanvas;

  return React.createElement(Box, {
    width: "100%",
    height: "100%",
    position: "relative",
    ref: parentEl,
    overflow: "hidden"
  }, React.createElement(OverLappingCanvas, {
    ref: waveformCanvas,
    "data-testid": testId
  }), !!(theme === null || theme === void 0 ? void 0 : theme.animOutSpeed) && theme.animOutSpeed > 0 && React.createElement(OverLappingCanvas, {
    "data-testid": testId + "-out-animation",
    ref: outAnimationCanvas
  }));
};

function timeToString(ms, delim) {
  if (delim === void 0) {
    delim = ':';
  }

  if (isNaN(ms)) {
    return '00:00';
  }

  var showWith0 = function showWith0(value) {
    return value < 10 ? "0" + value : "" + value;
  };

  var hours = showWith0(Math.floor(ms / (1000 * 60 * 60) % 60));
  var minutes = showWith0(Math.floor(ms / (1000 * 60) % 60));
  var seconds = showWith0(Math.floor(ms / 1000 % 60));
  return "" + (parseInt(hours, 10) ? "" + hours + delim : '') + minutes + delim + seconds;
}

var PlayheadLine = styled.div.attrs(function (_a) {
  var left = _a.left;
  return {
    style: {
      left: left + "px"
    }
  };
})(templateObject_1$1 || (templateObject_1$1 = __makeTemplateObject(["\n    pointer-events: none;\n    position: absolute;\n    width: 2px;\n    height: ", ";\n    bottom: 1px;\n    background-color: ", ";\n"], ["\n    pointer-events: none;\n    position: absolute;\n    width: 2px;\n    height: ", ";\n    bottom: 1px;\n    background-color: ", ";\n"])), function (_a) {
  var height = _a.height;
  return height + "px";
}, function (_a) {
  var color = _a.color;
  return color;
});
var PlayheadTime = styled.div(templateObject_2$1 || (templateObject_2$1 = __makeTemplateObject(["\n    position: absolute;\n    top: 0;\n    transform: translate(-50%, -100%);\n    min-width: 30px;\n    padding: 0 6px;\n    font-size: 11px;\n    line-height: 18px;\n    text-align: center;\n    background-color: ", ";\n    color: ", ";\n    border-radius: 100px;\n"], ["\n    position: absolute;\n    top: 0;\n    transform: translate(-50%, -100%);\n    min-width: 30px;\n    padding: 0 6px;\n    font-size: 11px;\n    line-height: 18px;\n    text-align: center;\n    background-color: ", ";\n    color: ", ";\n    border-radius: 100px;\n"])), function (_a) {
  var color = _a.color;
  return color;
}, function (_a) {
  var textColor = _a.textColor;
  return textColor;
});

var Playhead = function Playhead(_a) {
  var _b, _c, _d;

  var hoverPosition = _a.hoverPosition,
      height = _a.height,
      theme = _a.theme,
      hoverRatio = _a.hoverRatio,
      totalTime = _a.totalTime;

  if (hoverPosition === 0) {
    return null;
  }

  var hoverTime = hoverRatio * totalTime;
  var color = (_b = theme.playHeadColor) !== null && _b !== void 0 ? _b : DefaultThemeOriginal.playHeadColor;
  var textColor = (_c = theme.playHeadTextColor) !== null && _c !== void 0 ? _c : DefaultThemeOriginal.playHeadTextColor;
  var offSet = (_d = theme.playHeadTextOffset) !== null && _d !== void 0 ? _d : DefaultThemeOriginal.playHeadTextOffset;
  return React.createElement(PlayheadLine, {
    height: height + offSet,
    color: color,
    left: hoverPosition
  }, React.createElement(PlayheadTime, {
    color: color,
    textColor: textColor
  }, timeToString(hoverTime)));
};

var templateObject_1$1, templateObject_2$1;

function getEventXPosition(event) {
  return event.nativeEvent.offsetX;
}

var useWaveformProgress = function useWaveformProgress(playerClientRect, player, playOnSeek, onClickCallback, onMouseEnterCallback, onMouseLeaveCallback) {
  var _a = useState(0),
      hoverRatio = _a[0],
      setHoverRatio = _a[1];

  var getRatioFromPosition = useCallback(function (position) {
    return Math.max(Math.min(position / playerClientRect.width, 1), 0);
  }, [playerClientRect]);
  var getTimeFromPosition = useCallback(function (position) {
    return getRatioFromPosition(position) * player.totalTime;
  }, [getRatioFromPosition, player.totalTime]); // Seek action

  var onClick = useCallback(function (event) {
    var xPosition = getEventXPosition(event);
    var time = getTimeFromPosition(xPosition);

    if (onClickCallback) {
      onClickCallback(time);
    } else {
      player.seek(time, playOnSeek);
    }
  }, [getTimeFromPosition, player, playOnSeek, onClickCallback]); // Hover actions

  var onMouseMove = useCallback(function (event) {
    var xPosition = getEventXPosition(event);
    setHoverRatio(getRatioFromPosition(xPosition));

    if (onMouseEnterCallback) {
      onMouseEnterCallback(xPosition);
    }
  }, [getRatioFromPosition, onMouseEnterCallback]);
  var onMouseLeave = useCallback(function () {
    setHoverRatio(0);

    if (onMouseLeaveCallback) {
      onMouseLeaveCallback();
    }
  }, [onMouseLeaveCallback]);
  return {
    onClick: onClick,
    onMouseMove: onMouseMove,
    onMouseLeave: onMouseLeave,
    hoverRatio: hoverRatio
  };
};

var usePlayerWaveform = function usePlayerWaveform(_a) {
  var configOverride = _a.configOverride,
      playerId = _a.playerId,
      dataPoints = _a.dataPoints,
      _b = _a.playOnSeek,
      playOnSeek = _b === void 0 ? DefaultConfig.playOnSeek : _b,
      isResizable = _a.isResizable,
      themeOverride = _a.themeOverride,
      onClickCallback = _a.onClickCallback,
      onMouseEnterCallback = _a.onMouseEnterCallback,
      onMouseLeaveCallback = _a.onMouseLeaveCallback; // REF

  var parentEl = useRef(null); // CUSTOM

  var player = usePlayer(playerId); // STATE

  var _c = useState(0),
      hoverPosition = _c[0],
      setHoverPosition = _c[1];

  var masterDiff = useMemo(function () {
    if (dataPoints && dataPoints.differences && dataPoints.differences.length > 0) {
      return dataPoints.differences.find(function (diff) {
        return diff.id === player.activeSourceId;
      });
    }

    return undefined;
  }, [dataPoints, player.activeSourceId]);
  var playerClientRect = useBoundingClientRect(parentEl, isResizable);

  var _d = useWaveformProgress(playerClientRect, player, playOnSeek, onClickCallback, onMouseEnterCallback, onMouseLeaveCallback),
      handleOnClick = _d.onClick,
      onMouseMove = _d.onMouseMove,
      onMouseLeave = _d.onMouseLeave,
      hoverRatio = _d.hoverRatio;

  var handleOnMouseMove = useCallback(function (event) {
    onMouseMove(event);
    setHoverPosition(event.nativeEvent.offsetX);
  }, [onMouseMove, setHoverPosition]);
  var handleOnMouseLeave = useCallback(function (event) {
    onMouseLeave(event);
    setHoverPosition(0);
  }, [onMouseLeave, setHoverPosition]);
  var config = useMemo(function () {
    return __assign(__assign({}, DefaultConfig), configOverride);
  }, [configOverride]);
  var theme = useMemo(function () {
    var _a, _b;

    return {
      master: __assign(__assign({}, DefaultTheme.master), (_a = themeOverride === null || themeOverride === void 0 ? void 0 : themeOverride.master) !== null && _a !== void 0 ? _a : {}),
      original: __assign(__assign({}, DefaultTheme.original), (_b = themeOverride === null || themeOverride === void 0 ? void 0 : themeOverride.original) !== null && _b !== void 0 ? _b : {})
    };
  }, [themeOverride]);
  return {
    config: config,
    hoverPosition: hoverPosition,
    hoverRatio: hoverRatio,
    masterDiff: masterDiff,
    parentEl: parentEl,
    player: player,
    playerClientRect: playerClientRect,
    theme: theme,
    handleOnClick: handleOnClick,
    handleOnMouseLeave: handleOnMouseLeave,
    handleOnMouseMove: handleOnMouseMove
  };
};

var masterDiffValueFallback = [];
/**
 * Interactable waveform for player.
 * @param isResizable set to true to make waveform to adjust to parent's size, default value is `false`
 */

var PlayerWaveform = function PlayerWaveform(_a) {
  var _b;

  var playerId = _a.playerId,
      dataPoints = _a.dataPoints,
      configOverride = _a.config,
      themeOverride = _a.theme,
      isResizable = _a.isResizable,
      onClickCallback = _a.onClick,
      onMouseEnterCallback = _a.onMouseEnter,
      onMouseLeaveCallback = _a.onMouseLeave,
      outsideHoverRatio = _a.hoverRatio;

  var _c = usePlayerWaveform({
    configOverride: configOverride,
    playerId: playerId,
    dataPoints: dataPoints,
    isResizable: isResizable,
    playOnSeek: configOverride === null || configOverride === void 0 ? void 0 : configOverride.playOnSeek,
    themeOverride: themeOverride,
    onClickCallback: onClickCallback,
    onMouseEnterCallback: onMouseEnterCallback,
    onMouseLeaveCallback: onMouseLeaveCallback
  }),
      config = _c.config,
      hoverPosition = _c.hoverPosition,
      hoverRatio = _c.hoverRatio,
      masterDiff = _c.masterDiff,
      parentEl = _c.parentEl,
      player = _c.player,
      playerClientRect = _c.playerClientRect,
      theme = _c.theme,
      handleOnClick = _c.handleOnClick,
      handleOnMouseLeave = _c.handleOnMouseLeave,
      handleOnMouseMove = _c.handleOnMouseMove;

  return React.createElement(Box, {
    position: "relative",
    width: "100%",
    height: "100%",
    ref: parentEl,
    onClick: handleOnClick,
    onMouseMove: handleOnMouseMove,
    onMouseLeave: handleOnMouseLeave
  }, (dataPoints === null || dataPoints === void 0 ? void 0 : dataPoints.differences) && dataPoints.differences.length > 0 && React.createElement(Box, {
    position: "absolute",
    width: "100%",
    height: "100%",
    bottom: "0"
  }, React.createElement(Waveform, {
    dataPoints: dataPoints,
    currentTime: player.currentTime,
    totalTime: player.totalTime,
    testId: "master-canvas",
    config: config,
    theme: theme.master,
    isResizable: isResizable,
    hoverRatio: outsideHoverRatio !== null && outsideHoverRatio !== void 0 ? outsideHoverRatio : hoverRatio,
    masterDiffValue: (_b = masterDiff === null || masterDiff === void 0 ? void 0 : masterDiff.value) !== null && _b !== void 0 ? _b : masterDiffValueFallback
  })), React.createElement(Box, {
    position: "absolute",
    width: "100%",
    height: "100%",
    bottom: "0"
  }, React.createElement(Waveform, {
    dataPoints: dataPoints,
    currentTime: player.currentTime,
    totalTime: player.totalTime,
    testId: "original-canvas",
    config: config,
    theme: theme.original,
    isResizable: isResizable,
    hoverRatio: outsideHoverRatio !== null && outsideHoverRatio !== void 0 ? outsideHoverRatio : hoverRatio
  })), (configOverride === null || configOverride === void 0 ? void 0 : configOverride.hasPlayhead) && React.createElement(Playhead, {
    hoverRatio: hoverRatio,
    totalTime: player.totalTime,
    theme: theme.original,
    height: playerClientRect.height,
    hoverPosition: hoverPosition
  }));
};

var PlayerBar = function PlayerBar(_a) {
  var strokeColor = _a.strokeColor,
      strokeWidth = _a.strokeWidth,
      boxRadius = _a.boxRadius,
      circleRadius = _a.circleRadius;
  return React.createElement("circle", {
    cx: boxRadius,
    cy: boxRadius,
    r: circleRadius,
    stroke: strokeColor,
    fill: "none",
    strokeWidth: strokeWidth
  });
};

var PlayerProgress = function PlayerProgress(_a) {
  var dashArray = _a.dashArray,
      dashoffset = _a.dashoffset,
      strokeColor = _a.strokeColor,
      strokeWidth = _a.strokeWidth,
      boxRadius = _a.boxRadius,
      circleRadius = _a.circleRadius;
  return React.createElement("circle", {
    cx: boxRadius,
    cy: boxRadius,
    r: circleRadius,
    fill: "none",
    stroke: strokeColor,
    strokeWidth: strokeWidth,
    strokeDasharray: dashArray,
    strokeDashoffset: dashoffset,
    "aria-label": 'progress-bar'
  });
};

var PlayerScrubber = function PlayerScrubber(_a) {
  var handleX = _a.handleX,
      handleY = _a.handleY,
      fillColor = _a.fillColor;
  return React.createElement("circle", {
    "aria-label": 'player-scrubber',
    r: "6",
    fill: fillColor,
    cx: handleX,
    cy: handleY
  });
};

var PlayerSeekableZoneWrapper = styled.circle(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    cursor: pointer;\n"], ["\n    cursor: pointer;\n"])));

var PlayerSeekableZone = function PlayerSeekableZone(_a) {
  var onClick = _a.onClick,
      boxRadius = _a.boxRadius,
      circleRadius = _a.circleRadius;
  return React.createElement(PlayerSeekableZoneWrapper, {
    cx: boxRadius,
    cy: boxRadius,
    r: circleRadius,
    fill: "none",
    stroke: "transparent",
    strokeWidth: "20",
    onClick: onClick,
    "aria-label": 'seekable-zone'
  });
};

var WrapperButton = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    border-radius: 100%;\n    cursor: pointer;\n    transition: background-color 0.2s ease-in;\n    ", "\n\n    ", "\n        \n    ", "\n"], ["\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    border-radius: 100%;\n    cursor: pointer;\n    transition: background-color 0.2s ease-in;\n    ", "\n\n    ", "\n        \n    ", "\n"])), function (_a) {
  var boxRadius = _a.boxRadius;
  return boxRadius && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n            width: ", "px;\n            height: ", "px;\n        "], ["\n            width: ", "px;\n            height: ", "px;\n        "])), boxRadius + 25, boxRadius + 25);
}, function (_a) {
  var buttonColor = _a.buttonColor;
  return buttonColor && css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n            background-color: ", ";\n        "], ["\n            background-color: ", ";\n        "])), buttonColor);
}, function (_a) {
  var hoverButtonColor = _a.hoverButtonColor;
  return hoverButtonColor && css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n            &:hover {\n                background-color: ", ";\n            }\n        "], ["\n            &:hover {\n                background-color: ", ";\n            }\n        "])), hoverButtonColor);
});
var WrapperIcon = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    height: 28px;\n    width: 25px;\n"], ["\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    height: 28px;\n    width: 25px;\n"])));

var ToggleButton = function ToggleButton(_a) {
  var onClick = _a.onClick,
      isPlaying = _a.isPlaying,
      boxRadius = _a.boxRadius,
      buttonColor = _a.buttonColor,
      buttonLabel = _a.buttonLabel,
      hoverButtonColor = _a.hoverButtonColor,
      iconColor = _a.iconColor;
  return React.createElement(WrapperButton, {
    "aria-label": buttonLabel,
    onClick: onClick,
    boxRadius: boxRadius,
    buttonColor: buttonColor,
    hoverButtonColor: hoverButtonColor
  }, React.createElement(WrapperIcon, null, !isPlaying ? React.createElement("svg", {
    width: "28",
    height: "28",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M0 0h48v48H0z"
  }), React.createElement("path", {
    fill: iconColor,
    d: "M16 42l24-17.997L16 6z"
  }))) : React.createElement("svg", {
    width: "28",
    height: "28",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M0 0h48v48H0z"
  }), React.createElement("path", {
    d: "M27 7h7v34h-7V7zM14 7h7v34h-7V7z",
    fill: iconColor
  })))));
};

var AlbumStepsDividerLine = function AlbumStepsDividerLine(_a) {
  var x1 = _a.x1,
      y1 = _a.y1,
      x2 = _a.x2,
      y2 = _a.y2,
      strokeColor = _a.strokeColor;
  return React.createElement("line", {
    x1: x1,
    y1: y1,
    x2: x2,
    y2: y2,
    fill: "none",
    strokeWidth: "4",
    stroke: strokeColor,
    className: 'album-divider'
  });
};

var WrapperDivider = styled.g(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    transform-origin: center;\n    transform: rotate(90deg);\n"], ["\n    transform-origin: center;\n    transform: rotate(90deg);\n"])));
var PlayerWrapper = styled.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    position: relative;\n    ", "\n    ", "\n"], ["\n    position: relative;\n    ", "\n    ", "\n"])), function (_a) {
  var width = _a.width;
  return width && css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n            width: ", "px;\n        "], ["\n            width: ", "px;\n        "])), width);
}, function (_a) {
  var height = _a.height;
  return height && css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n            height: ", "px;\n        "], ["\n            height: ", "px;\n        "])), height);
});
var SvgContainer = styled.svg(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    transform: rotate(-90deg);\n"], ["\n    transform: rotate(-90deg);\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11;
var DefaultCirclePlayerConfig = {
  circleWidth: 140,
  strokeWidth: '2',
  progressStrokeWidth: '2.5',
  backgroundColor: '#ffffff',
  strokeColor: '#c5cdd5',
  progressStrokeColor: '#32cbcb',
  scrubberColor: '#32cbcb',
  buttonColor: 'rgba(52, 52, 52, 1)',
  buttonLabel: 'Play/Pause button',
  hoverButtonColor: 'rgba(52, 52, 52, 0.8)',
  iconColor: '#ffffff'
};

var CirclePlayer = function CirclePlayer(_a) {
  var playerId = _a.playerId,
      _b = _a.themeConfig,
      themeConfigOverride = _b === void 0 ? {} : _b,
      _c = _a.tracksCount,
      tracksCount = _c === void 0 ? 1 : _c,
      onPlayButtonClick = _a.onPlayButtonClick,
      onPauseButtonClick = _a.onPauseButtonClick;

  var themeConfig = __assign(__assign({}, DefaultCirclePlayerConfig), themeConfigOverride);

  var _d = usePlayer(playerId),
      totalTime = _d.totalTime,
      seek = _d.seek,
      currentTime = _d.currentTime,
      playing = _d.playing,
      setPlaying = _d.setPlaying; // There's some padding so if we want the exact size I need to add the padding amount


  var adjustedCircleWidth = themeConfig.circleWidth + 20;
  var boxRadius = adjustedCircleWidth / 2;
  var circleRadius = boxRadius - 11;
  var dashArray = 2 * Math.PI * circleRadius;

  var _e = useState(0),
      dashoffset = _e[0],
      setDashoffset = _e[1];

  var _f = useState(0),
      handleX = _f[0],
      setHandleX = _f[1];

  var _g = useState(0),
      handleY = _g[0],
      setHandleY = _g[1];

  var dividersToRender = useMemo(function () {
    var dividerAngle = 2 * Math.PI / tracksCount;
    var dividerArray = [];

    for (var i = 0; i < tracksCount; i++) {
      var currentAngle = Math.PI + i * dividerAngle;
      var widerRadius = circleRadius + 5;
      var x = Math.round(Math.sin(currentAngle) * widerRadius) + boxRadius;
      var y = Math.round(Math.cos(currentAngle) * widerRadius) + boxRadius;
      dividerArray.push(React.createElement(AlbumStepsDividerLine, {
        key: "step-" + i,
        x1: boxRadius,
        y1: boxRadius,
        x2: x,
        y2: y,
        strokeColor: themeConfig.backgroundColor
      }));
    }

    return dividerArray;
  }, [tracksCount]);
  useEffect(function () {
    var ratio = totalTime > 0 ? currentTime / totalTime : 0;
    var radian = 2 * Math.PI * ratio;
    var dashArray = 2 * Math.PI * circleRadius;
    setHandleX(circleRadius * Math.cos(radian) + boxRadius);
    setHandleY(circleRadius * Math.sin(radian) + boxRadius);
    setDashoffset(dashArray - dashArray * ratio);
  }, [totalTime, currentTime, circleRadius]);
  var handleSeek = useCallback(function (event) {
    var targetX = event.nativeEvent.offsetX;
    var targetY = event.nativeEvent.offsetY;
    var angle = Math.atan2(targetY - boxRadius, targetX - boxRadius) + Math.PI / 2;
    var ratio = angle / (2 * Math.PI) * totalTime - totalTime * 0.25;
    var currentTime = Math.round(ratio <= 0 ? ratio + totalTime : ratio);
    seek(currentTime, true);
  }, [totalTime, seek]);
  var handlePlay = useCallback(function () {
    var isPlaying = !playing;

    if (isPlaying && onPlayButtonClick) {
      onPlayButtonClick(playerId);
    } else if (onPauseButtonClick) {
      onPauseButtonClick(playerId);
    }

    setPlaying(isPlaying);
  }, [playing, playerId, onPlayButtonClick, onPauseButtonClick]);
  return React.createElement(PlayerWrapper, {
    width: boxRadius * 2,
    height: boxRadius * 2
  }, React.createElement(SvgContainer, {
    width: boxRadius * 2,
    height: boxRadius * 2,
    viewBox: " 0 0 " + boxRadius * 2 + " " + boxRadius * 2
  }, React.createElement(PlayerBar, {
    strokeColor: themeConfig.strokeColor,
    strokeWidth: themeConfig.strokeWidth,
    boxRadius: boxRadius,
    circleRadius: circleRadius
  }), React.createElement(PlayerProgress, {
    strokeColor: themeConfig.progressStrokeColor,
    strokeWidth: themeConfig.progressStrokeWidth,
    dashArray: dashArray,
    dashoffset: dashoffset,
    boxRadius: boxRadius,
    circleRadius: circleRadius
  }), tracksCount > 1 && React.createElement(WrapperDivider, {
    "aria-label": 'wrapper-dividers',
    width: boxRadius * 2,
    height: boxRadius * 2
  }, dividersToRender), React.createElement(PlayerScrubber, {
    fillColor: themeConfig.scrubberColor,
    handleX: handleX,
    handleY: handleY
  }), React.createElement(PlayerSeekableZone, {
    onClick: function onClick(event) {
      handleSeek(event);
    },
    boxRadius: boxRadius,
    circleRadius: circleRadius
  })), React.createElement(ToggleButton, {
    onClick: handlePlay,
    isPlaying: playing,
    boxRadius: boxRadius,
    buttonColor: themeConfig.buttonColor,
    buttonLabel: themeConfig.buttonLabel,
    hoverButtonColor: themeConfig.hoverButtonColor,
    iconColor: themeConfig.iconColor
  }));
};

export { CirclePlayer, PlayerProvider, PlayerStateEnum, PlayerWaveform, Waveform, usePlayer };